<template>
  <div class="space-y-3">
    <div @click="mode = 'zoom'" class="aspect-4/3 w-full overflow-hidden rounded-md relative group">
      <img :src="currentImage.url" :alt="alt" class="w-full h-full object-cover " loading="lazy" />
      <div class="absolute top-0 left-0 w-full h-full flex items-center justify-center bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity">
        <UIcon name="i-heroicons-magnifying-glass-plus" class="w-8 h-8 text-white" />
      </div>
    </div>

    <UCarousel v-slot="slide" :items="images" arrows :ui="{
      item: 'basis-1/4 ps-4',
      container: 'pr-12',
      prev: 'left-0! translate-x-[-50%] scale-75',
      next: 'right-0! translate-x-[50%] scale-75',
      }">
      <img @click="thumbSelect(slide.index)" :src="slide.item.url" :alt="`${alt} - ${slide.index + 1}`" class="w-full h-22 object-cover rounded-md" loading="lazy" :class="{
        'opacity-70 hover:opacity-100 cursor-pointer': slide.index !== index
      }" />
    </UCarousel>
  </div>
  <UModal
  :close="{ onClick: () => {
    mode = 'regular'
  } }"
  :title="alt" :open="mode === 'zoom'" :fullscreen="true" size="xl">
    <!-- <template #header>
      <h3 class="text-lg font-medium">Image Preview</h3>
    </template> -->
    <template #body>
      <div class="w-full h-full flex items-center justify-center" >
         <UCarousel :start-index="index" v-slot="slide" :items="images" arrows dots :ui="{
          root: 'h-full',
          viewport: 'h-full',
          container: 'h-full',
          item: 'basis-1/1 ps-4 h-full',
          prev: 'left-0!',
          next: 'right-0!',
          dots: 'bottom-4',
      }">
      <img @click="thumbSelect(slide.index)" :src="slide.item.url" :alt="`${alt} - ${slide.index + 1}`" class="w-full h-full object-contain rounded-md" loading="lazy" :class="{
        'opacity-70 hover:opacity-100 cursor-pointer': slide.index !== index
      }" />
    </UCarousel>
      </div>
    </template>
  </UModal>
</template>
<script setup lang="ts">
import type { ProductImage } from '~/types'

const props = defineProps<{ images: ProductImage[]; alt?: string }>()

const images = computed(() => props.images.length ? props.images : [
  { id: 0, url: '/img/placeholder.jpg', isPrimary: true }
])

const index = ref(0)
const currentImage = computed(() => images.value[index.value] || images.value[0] as ProductImage)
const mode = ref('regular');



function thumbSelect(i: number) {
  index.value = i
}
</script>
